/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function Firms(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg
                viewBox='0 0 27.93 20.65'
                xmlns='http://www.w3.org/2000/svg'
            >
                <title>Firms</title>
                <g
                    data-name='Layer 2'
                    id='Layer_2'
                >
                    <g
                        data-name='Layer 1'
                        fill={iconColor || '#000'}
                        id='Layer_1-2'
                    >
                        <g id='Rectangle'>
                            <path d='M24,17.51H.5A.51.51,0,0,1,0,17V.5A.51.51,0,0,1,.5,0H24a.5.5,0,0,1,.5.5V17A.5.5,0,0,1,24,17.51Zm-23-1h22.5V1H1Z' />
                        </g>
                        <g id='Line'>
                            <path d='M16.48,4.31H4.42a.51.51,0,1,1,0-1H16.48a.51.51,0,0,1,0,1Z' />
                        </g>
                        <g id='Line-Copy'>
                            <path d='M12.93,7.61H4.42a.51.51,0,1,1,0-1h8.51a.51.51,0,1,1,0,1Z' />
                        </g>
                        <g id='Line-Copy-2'>
                            <path d='M10.3,10.91H4.42a.51.51,0,1,1,0-1H10.3a.51.51,0,0,1,0,1Z' />
                        </g>
                        <path d='M27.36,20.65H7.6A.57.57,0,0,1,7,20.08a.58.58,0,0,1,.58-.58H26.78V8.1a.58.58,0,0,1,.58-.58.57.57,0,0,1,.57.58v12A.56.56,0,0,1,27.36,20.65Z' />
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}